const productDetailReviews = [
  { 
    name: "Aditya Verma", 
    text: "Excellent quality and performance, highly recommended!", 
    stars: 5 
  },
  { 
    name: "Priya Nair", 
    text: "Fast delivery and well-packaged. Satisfied with my purchase!", 
    stars: 4 
  },
  { 
    name: "Rohan Mehta", 
    text: "Good product, but could be priced better.", 
    stars: 3 
  },
  { 
    name: "Snehal Deshmukh", 
    text: "Decent experience, but expected better features.", 
    stars: 3 
  },
  { 
    name: "Karan Malhotra", 
    text: "Great value for money. Will buy again!", 
    stars: 5 
  },
];

export default productDetailReviews;
